import { render, staticRenderFns } from "./TableResultsOrganic.vue?vue&type=template&id=f07f9c4c&scoped=true&"
import script from "./TableResultsOrganic.vue?vue&type=script&lang=js&"
export * from "./TableResultsOrganic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f07f9c4c",
  null
  
)

export default component.exports